import { getUnitOfSale } from "../../formatting/domain-value-manipulation";
import type { CommercialInfo, OutcomesByVersion } from "../../types";
import type { Field } from "../tabs/types";

export function buildUnitOfSaleField(
  outcomes?: OutcomesByVersion,
  index = 0,
): Field {
  return {
    name: "Unit of Sale",
    type: "text",
    index,
    value: getUnitOfSale(outcomes),
  };
}

export function buildMinimumOrderField(
  commercialInformation?: CommercialInfo,
  index = 0,
): Field {
  return {
    name: "Minimum order",
    type: "text",
    index,
    value: commercialInformation?.minimumOrder,
  };
}
